import { render, staticRenderFns } from "./Namespaces.vue?vue&type=template&id=6ad5d9f9&"
import script from "./Namespaces.vue?vue&type=script&lang=js&"
export * from "./Namespaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports